import * as e from "react";
import { P as o } from "./index-Bm60c36x.js";
import { jsx as t } from "react/jsx-runtime";
var d = "VisuallyHidden", a = e.forwardRef(
  (r, i) => /* @__PURE__ */ t(
    o.span,
    {
      ...r,
      ref: i,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...r.style
      }
    }
  )
);
a.displayName = d;
var m = a;
export {
  m as R,
  a as V
};
